import { useState, useEffect } from "react";
import getSlotInfo from 'utils/getSlotInfo';

function useDestination(searchParam) {
  const [destination, setDestination] = useState(null);

  useEffect(() => {
    const query = new URLSearchParams(searchParam);
    const code = query.get("code");
    const targetSlotInfo = getSlotInfo(code);
    if (targetSlotInfo) {
      setDestination(targetSlotInfo);
    } else {
      setDestination(null);
    }
  }, [searchParam]);

  return destination;
}

export default useDestination;
